import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import aboutImage from './../assets/pexels/about-1.jpg'
import SmallHeading from './../components/SmallHeading';
import Heading from './../components/Heading';

const AboutUs = () => {
  return (
    <section id="about" className="py-10">
      <SmallHeading name="About Us" tstyle="text-center my-1 mt-10"/>
      <Heading name="What we do" tstyle="text-center my-1"/>
      
      <div className="container mx-auto px-5 mt-6">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>   
            {/* <h1 className="text-emerald-600 uppercase text-lg font-bold my-1">About Us</h1> */}
            <p className="mb-4 text-justify">
              At PocketLPO, we empower businesses with flexible, cost-effective, and expert legal support. Our mission is
              to bridge the gap between strategic legal advice and affordability by providing top-tier remote in-house counsel services.
            </p>
            <h1 className="uppercase text-lg font-bold my-1">Our Story</h1>
            <p className="mb-4 text-justify">
            Created with a vision to revolutionize legal services, PocketLPO brings together experienced legal professionals dedicated
            to offering exceptional support without the overhead of a full-time legal team. We help businesses of all sizes navigate 
            complex legal landscapes with confidence.
            </p>
            <h1 className="uppercase text-lg font-bold my-1">Our Expertise</h1>
            <p className="mb-4 text-justify">
            We specialize in:
            </p>
            <div className="grid grid-cols-2 gap-4 mt-6">
              <div>
                <h5 className="mb-3 flex items-center font-semibold">
                  <FontAwesomeIcon className="text-emerald-600 text-2xl mr-3" icon={faCheck}/>
                  Contract Management & Review</h5>
                  <h5 className="mb-3 flex items-center font-semibold">
                  <FontAwesomeIcon className="text-emerald-600 text-2xl mr-3" icon={faCheck} />
                  Compliance & Risk Management</h5>
                  <h5 className="mb-3 flex items-center font-semibold">
                  <FontAwesomeIcon className="text-emerald-600 text-2xl mr-3" icon={faCheck} />
                  Data Privacy & Protection</h5>
              </div>
              <div>
                 <h5 className="mb-3 flex items-center font-semibold">
                  <FontAwesomeIcon className="text-emerald-600 text-2xl mr-3" icon={faCheck} />
                  Intellectual Property Protection</h5>
                  <h5 className="mb-3 flex items-center font-semibold">
                  <FontAwesomeIcon className="text-emerald-600 text-2xl mr-3" icon={faCheck} />
                  Corporate Governance & Structuring</h5>
              </div>
            </div>
          </div>          
          <div className="relative min-h-[500px]">
            <img
              className="absolute w-full h-full object-cover rounded-lg"
              src={aboutImage}
              alt="About Us"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
